// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"05681634","879":"c54599de"}[chunkId] + ".chunk.js";
};